import { useState, useEffect } from 'react';
import WholesaleLayout, { useWholesaleAuth } from './WholesaleLayout';
import { getWholesaleProfile, updateWholesaleProfile, requestWholesaleUnlock } from '../../lib/api';

export default function WholesaleProfile() {
  const user = useWholesaleAuth('wholesale');
  const [profile, setProfile] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = () => {
    if (user) getWholesaleProfile(user.username).then(r => setProfile(r.data)).catch(() => {});
  };
  useEffect(load, [user]);

  const handleSave = async () => {
    if (!profile) return;
    setSaving(true);
    try {
      await updateWholesaleProfile(user.username, profile);
      alert('Profile saved');
    } catch (e) { alert(e.response?.data?.detail || 'Save failed'); }
    setSaving(false);
  };

  const handleRequestUnlock = async () => {
    try {
      await requestWholesaleUnlock(user.username);
      setProfile(p => ({ ...p, edit_requested: true }));
    } catch (e) { alert(e.response?.data?.detail || 'Request failed'); }
  };

  if (!profile) return <WholesaleLayout user={user} title="Profile"><div style={{ color:'#888' }}>Loading...</div></WholesaleLayout>;

  const locked = profile.locked;
  const fields = [
    { key:'company_name', label:'Company Name' }, { key:'contact_person', label:'Contact Person' },
    { key:'email', label:'Email' }, { key:'phone', label:'Phone' },
    { key:'address', label:'Address' }, { key:'city', label:'City' },
    { key:'zip', label:'ZIP / Postal Code' }, { key:'country', label:'Country' },
  ];

  return (
    <WholesaleLayout user={user} title="Profile">
      {locked && (
        <div style={{ background:'#FFF3E0', border:'1px solid #FFB74D', borderRadius:4, padding:'14px 20px', marginBottom:20, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <span style={{ fontSize:13, color:'#E65100', fontWeight:600 }}>Profile is locked by admin. Contact admin to make changes.</span>
          {profile.edit_requested ? (
            <span style={{ fontSize:11, color:'#888', fontWeight:600, letterSpacing:1 }}>UNLOCK REQUESTED</span>
          ) : (
            <button onClick={handleRequestUnlock} data-testid="request-unlock-btn" style={btnOutline}>Request Unlock</button>
          )}
        </div>
      )}
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:32 }}>
        <div style={card}>
          <div style={cardTitle}>Profile Details</div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>
            {fields.map(f => (
              <div key={f.key} style={f.key === 'address' ? { gridColumn:'1/-1' } : {}}>
                <label style={labelStyle}>{f.label}</label>
                <input value={profile[f.key] || ''} disabled={locked} onChange={e => setProfile(p => ({ ...p, [f.key]: e.target.value }))}
                  style={{ ...inputStyle, ...(locked ? { background:'#F7F6F2', color:'#888' } : {}) }} data-testid={`profile-${f.key}`} />
              </div>
            ))}
          </div>
          {!locked && (
            <button onClick={handleSave} disabled={saving} data-testid="profile-save-btn"
              style={{ ...btnPrimary, marginTop:20 }}>{saving ? 'Saving...' : 'Save Profile'}</button>
          )}
        </div>
        <div style={card}>
          <div style={cardTitle}>Shipping Label Preview</div>
          <div style={{ background:'#F7F6F2', padding:20, borderRadius:2, fontFamily:'monospace', fontSize:13, lineHeight:1.8 }}>
            {profile.contact_person && <div style={{ fontWeight:700 }}>{profile.contact_person}</div>}
            {profile.company_name && <div>{profile.company_name}</div>}
            {profile.address && <div>{profile.address}</div>}
            {(profile.city || profile.zip) && <div>{[profile.city, profile.zip].filter(Boolean).join(' — ')}</div>}
            {profile.country && <div>{profile.country}</div>}
            {profile.phone && <div>{profile.phone}</div>}
            {profile.email && <div>{profile.email}</div>}
          </div>
        </div>
      </div>
    </WholesaleLayout>
  );
}

const card = { background:'#fff', border:'1px solid #E0DED8', borderRadius:4, padding:24 };
const cardTitle = { fontFamily:"'Barlow Condensed',sans-serif", fontSize:16, fontWeight:700, letterSpacing:1.5, textTransform:'uppercase', marginBottom:16 };
const labelStyle = { display:'block', fontSize:11, letterSpacing:1.5, textTransform:'uppercase', fontWeight:600, color:'#888', marginBottom:6 };
const inputStyle = { width:'100%', padding:'10px 12px', border:'1px solid #E0DED8', borderRadius:2, fontFamily:'Barlow', fontSize:13, outline:'none' };
const btnPrimary = { display:'inline-flex', alignItems:'center', gap:6, padding:'8px 16px', fontFamily:'Barlow', fontSize:12, fontWeight:600, letterSpacing:1, textTransform:'uppercase', borderRadius:2, cursor:'pointer', background:'#C41E2A', color:'#fff', border:'none' };
const btnOutline = { display:'inline-flex', alignItems:'center', gap:6, padding:'8px 16px', fontFamily:'Barlow', fontSize:12, fontWeight:600, letterSpacing:1, textTransform:'uppercase', borderRadius:2, cursor:'pointer', background:'transparent', color:'#111', border:'1.5px solid #111' };
